const Chords = {
    C: {
      notes: ['C', 'E', 'G'],
      colors: { 'C': 'bg-blue-600', 'E': 'bg-blue-600', 'G': 'bg-blue-600' }
    },
    G: {
      notes: ['D', 'G', 'B'],
      colors: { 'D': 'bg-purple-600', 'G': 'bg-purple-600', 'B': 'bg-purple-600' }
    },
    Am: {
      notes: ['C', 'E', 'A'],
      colors: { 'C': 'bg-green-400', 'E': 'bg-green-400', 'A': 'bg-green-400' }
    },
    F: {
      notes: ['C', 'F', 'A'],
      colors: { 'C': 'bg-red-600', 'F': 'bg-red-600', 'A': 'bg-red-600' }
    },
    D: {
      notes: ['D', 'F#', 'A'],
      colors: { 'D': 'bg-cyan-600', 'F#': 'bg-cyan-600', 'A': 'bg-cyan-600' }
    },
    A: {
      notes: ['A', 'C#', 'E'],
      colors: { 'A': 'bg-green-600', 'C#': 'bg-green-600', 'E': 'bg-green-600' }
    },
    Bm: {
      notes: ['B', 'D', 'F#'],
      colors: { 'B': 'bg-pink-400', 'D': 'bg-pink-400', 'F#': 'bg-pink-400' }
    },
    E: {
      notes: ['E', 'G#', 'B'],
      colors: { 'E': 'bg-gray-600', 'G#': 'bg-gray-600', 'B': 'bg-gray-600' }
    },
    B: {
      notes: ['B', 'D#', 'F#'],
      colors: { 'B': 'bg-pink-600', 'D#': 'bg-pink-600', 'F#': 'bg-pink-600' }
    },
    FH: {
      notes: ['F#', 'A#', 'C#'],
      colors: { 'F#': 'bg-red-800', 'A#': 'bg-red-800', 'C#': 'bg-red-800' }
    },
    CHm: {
      notes: ['C#', 'E', 'G#'],
      colors: { 'C#': 'bg-blue-800', 'E': 'bg-blue-800', 'G#': 'bg-blue-800' }
    },
    Dm: {
      notes: ['D', 'F', 'A'],
      colors: { 'D': 'bg-cyan-400', 'F': 'bg-cyan-400', 'A': 'bg-cyan-400' }
    },
    Bb: {
      notes: ['Bb', 'D', 'F'],
      colors: { 'A#': 'bg-pink-800', 'D': 'bg-pink-800', 'F': 'bg-pink-800' }
    },
    Em: {
      notes: ['E', 'G', 'B'],
      colors: { 'E': 'bg-gray-400', 'G': 'bg-gray-400', 'B': 'bg-gray-400' }
    },
    FHm: {
      notes: ['F#', 'A', 'C#'],
      colors: { 'F#': 'bg-red-800', 'A': 'bg-red-800', 'C#': 'bg-red-800' }
    },
    GHm: {
      notes: ['G#', 'B', 'D#'],
      colors: { 'G#': 'bg-purple-800', 'B': 'bg-purple-800', 'D#': 'bg-purple-800' }
    }
  };
  
  export default Chords;